<template>

    <div id="cabecalho" class="container-fluid align-items-center" :class="{'mobileOpen':mobileOpen}" ref="cabecalho">
            

            
            <div class='menu-bars' :class="{'mobileOpen':mobileOpen}">
                <i class='fa fa-bars' @click="mobileOpen = !mobileOpen"></i>
            </div>
            
            <div id="logowrap">
              <router-link to="/" id="logo">
                   <h1 id="logo-title"> <div>VOLTA DO</div> <div class='lago'> LAGO CAIXA </div> </h1>            
                </router-link >
            </div> 

    
             <div id="menu-wrap" :class="{'mobileOpen':mobileOpen}">

                         <div id="grandientHeader"></div>
                



                        <!--  -->
                        


                        <div class="menu-list" :class="{'mobileOpen':mobileOpen}">

                                <div class="fechar"  > <i  @click="mobileOpen = false" class='fa fa-times'></i> </div>
                               

                                <vtl-menu label="Prova" icon="vtl vtl-prova">
                                        <!-- <vtl-menu to="/prova/regras" label="Regras" icon="fa fa-newspaper-o"> </vtl-menu> -->
                                        <vtl-menu to="/prova/regulamento" label="Regulamento" icon="fa fa-newspaper-o"> </vtl-menu>
                                        <vtl-menu to="/prova/kit-do-atleta" label="Kit do Atleta" icon="vtl vtl-kit-atleta"> </vtl-menu>
                                        <!-- <vtl-menu to="/prova/valores" label="Valores" icon="fa fa-usd fa-fw">
                                        </vtl-menu> -->
                                        <!-- <vtl-menu to="https://largadaesportiva.com.br/event/13" target="_blank" label="Inscreva-se" icon="fa fa-sign-in"> </vtl-menu> -->
                                        <vtl-menu to="/marca-voltalago-20-edicao.zip" target="_blank" label="Imprensa/marcas" icon="fa fa-download"> </vtl-menu>
                                </vtl-menu>

                                <vtl-menu label="Percurso" icon="vtl vtl-percurso">
                                        <vtl-menu to="/percurso/trechos" label="Trechos" icon="vtl vtl-trecho fa-fw"> </vtl-menu>
                                        <vtl-menu  to="/percurso/altimetria" toogle="/"  label="Altimetria" icon="vtl vtl-altimetria fa-fw"> </vtl-menu>
                                        <vtl-menu to="/percurso/calculo-de-ritmo"  label="Cal. de Ritmo" icon="vtl vtl-resultado fa-fw"></vtl-menu>
                                        <vtl-menu to="/percurso/planejamento"  label="Planejamento" icon="vtl vtl-planejamento fa-fw"> </vtl-menu>
                                        <vtl-menu to="/images/volta-do-lago-2026.pdf" target="_blank" label="Imprimir" icon="fa fa-print fa-fw"> </vtl-menu>
                                        <vtl-menu to="/images/voltadolago-100Km.gpx" target="_blank" label="Rota em GPX - 100KM" icon="fa fa-map-marker fa-fw"> </vtl-menu>
                                        <vtl-menu to="/images/voltadolago-70Km.gpx" target="_blank" label="Rota em GPX - 70KM" icon="fa fa-map-marker fa-fw"> </vtl-menu>
                                        <vtl-menu to="/images/voltadolago-50Km.gpx" target="_blank" label="Rota em GPX - 50KM" icon="fa fa-map-marker fa-fw"> </vtl-menu>
                                        <vtl-menu to="https://www.strava.com/routes/3376256250801668994" target="_blank" label="Strava" icon="fa fa-map-marker fa-fw"> </vtl-menu>
                                        <!-- <vtl-menu to="/images/percurso-voltadolago-2024v2.pdf" target="_blank" label="Imprimir" icon="fa fa-print fa-fw"> </vtl-menu> -->
                                </vtl-menu>

                                <vtl-menu label="Equipe" icon="vtl vtl-equipe">
                                        <vtl-menu to="https://largadaesportiva.com.br/myregistrations" label="Minhas Eq." icon="vtl vtl-equipe">
                                        </vtl-menu> 
                                        <!-- <vtl-menu to="/procuroequipes" label="Procuro Eq." icon="vtl vtl-equipe">
                                        </vtl-menu>-->
                                        <vtl-menu to="/equipes/inscritas" label="Inscritas" icon="fa fa-flag-checkered">
                                        </vtl-menu> 
                                </vtl-menu> 
                        
                                <vtl-menu label="Resultados" icon="vtl vtl-resultado">
                                        <vtl-menu to="" :disable="true" label="Interativo" icon="vtl vtl-trecho fa-fw"> </vtl-menu>
                                        <vtl-menu to="http://voltadolago.com.br/resultado_oficial_20_edicao.html" label="20º Edição - Resultado Oficial" icon="vtl vtl-resultado fa-fw"> </vtl-menu>
                                        <vtl-menu to="http://voltadolago.com.br/images/resultado-20-revezamento.pdf" label="20º Edição - Revezamento (pdf)" icon="vtl vtl-resultado fa-fw"> </vtl-menu>
                                        <vtl-menu to="http://voltadolago.com.br/images/resultado-20-individual.pdf" label="20º Edição - Solo (pdf)" icon="vtl vtl-resultado fa-fw"> </vtl-menu>
                                        <vtl-menu to="//voltadolago.com.br/images/resultado-19-equipe-oficial.pdf" label="19º Equipe" icon="vtl vtl-resultado fa-fw"> </vtl-menu>
                                        <vtl-menu to="http://voltadolago.com.br/images/resultado-19-solo-oficial.pdf" label="19º Solo" icon="vtl vtl-resultado fa-fw"> </vtl-menu>
                                        <vtl-menu to="http://voltadolago.com.br/images/resultado-18-voltadolago.pdf" label="18º Edição" icon="vtl vtl-resultado fa-fw"> </vtl-menu>
                                        <vtl-menu to="http://voltadolago.com.br/images/resultado-oficial-17-v2.pdf" label="17º Edição" icon="vtl vtl-resultado fa-fw"> </vtl-menu>
                                        <vtl-menu to="http://voltadolago.com.br/images/resultado-oficial-16-voltadolago.pdf" label="16º Edição" icon="vtl vtl-resultado fa-fw"> </vtl-menu>
                                        <!-- <vtl-menu to="http://voltadolago.com.br/images/Parciais2_2019_Ultra.pdf" label="16º Parc. Ultra" icon="vtl vtl-resultado fa-fw"> </vtl-menu> -->
                                        <!-- <vtl-menu to="http://voltadolago.com.br/images/Res_Cat_Lago_2019.pdf" label="16º Parc. Cat" icon="vtl vtl-resultado fa-fw"> </vtl-menu> -->
                                        <vtl-menu to="http://voltadolago.com.br/images/resultado-oficial.pdf" label="15º Edição" icon="vtl vtl-resultado fa-fw"> </vtl-menu>
                                        <!-- <vtl-menu to="http://voltadolago.com.br/images/resultado-parciais-2018.pdf" label="15º Ed. Parciais" icon="vtl vtl-resultado fa-fw"> </vtl-menu> -->
                                        <!-- <vtl-menu to="http://voltadolago.com.br/files/8815/0031/0404/Resultado_14_Volta_do_Lago_CAIXA_-_FINAL.PDF" label="14º Edição" icon="vtl vtl-resultado fa-fw"> </vtl-menu> -->
                                        <!-- <vtl-menu to="http://voltadolago.com.br/files/4914/6602/7219/RESULTADO_GERAL_OFICIAL_2016.pdf" label="13º Edição" icon="vtl vtl-resultado fa-fw"> </vtl-menu> -->
                                </vtl-menu>

                            

                                <vtl-menu label="Contato" icon="fa fa-envelope-o" to="/pagina/contato">
                                </vtl-menu>


                                <div id='lang-selector' class="">
                                    <a :class="{active:currentLang=='en'}" @click='changeLanguage("en")'>{{ $t('EN') }}</a><a :class="{active:currentLang=='pt'}" @click='changeLanguage("pt")'>{{ $t('PT') }}</a>
                                </div>

                        </div>

            </div>



           </div>





</template>

<script>
    
    export default {

        data(){
            return {
                mobileOpen:false,
            }
        },


        computed:{
                currentLang:function(){
                    return this.$store.getters.currentLang
                }
        },

       watch: {
            // call again the method if the route changes
            '$route':function (to, from) {
       
                this.mobileOpen = false; //fecho o menu 
                //vejo se tem meta de conteudo, e o tamanho do conteudo ou a sua classe

            },

            mobileOpen:function(val){
                if(val){
                    $('html').addClass('mobileOpen')
                }else{
                    $('html').removeClass('mobileOpen')

                }
            }
        },

        created:function(){
            // $(window).resize(()=>{
                    // var conteudoWidth = ($('#conteudo-container').width() || 0);     
                    // TweenMax.to( "#menu-wrap" ,0.02,{x:conteudoWidth});
            // })
        },

        methods:{
            changeLanguage:function(lang){
                    this.$store.dispatch('setCurrentLang',lang);
                    //mudo a url
                    if(this.$route.params.lang){
                        var langActual = this.$route.params.lang;
                        if(langActual != lang){
                            var path = this.$route.path;
                            path = path.replace(`/${langActual}/`,`/${lang}/`);
                            this.$router.push(path);
                        }
                    }
            }

        }

    }

</script>


<style lang="stylus" >

    @import "../css/variaveis";
    
    // CABECALHO

    #cabecalho{
            box t 0 l 0 w 115 b 0
            z-index:0;
            margin:0;
            padding:0;
            padding-top:0px;
            // overflow:hidden;
            // bkg gradient           
            &:hover:before{
                opacity 1;    
                transition: all 400ms;
            }

                 +mobile(){
                     position:fixed !important;
                     z-index:10000;
                 }
    }



    // MENU - list
    .menu-list{
        
        .fechar{
           
            position:fixed;
            width:100%;
            text-align:left;
            opacity:1;
            padding: 0.8em;
            padding-left: 1em;
            top:0
            margin-bottom:1em;
            i{
                color:white;
                cursor:pointer;
                font-size:25px;
            }

             display:none !important
        }
    
        +mobile(){

                box t 0 l 0 w 115 b 0

                padding-top:50px;
                transform:initial !important;
            
                background: color-orange !important;
                z-index:9999;
                overflow:auto;
                transition left 200ms;
                
                transition all 200ms;
                z-index:999;
                
                width 70vw;
                left -70vw;

                display: flex;
                flex-flow: column;
                display:block;

                &.mobileOpen{
                    // display:block;
                    left:0;
                    transition left 200ms;
                     box-shadow: 5px 1px 10px 0 rgba(black,0.5)
                    .fechar{
                        display:block !important;
                    }

                }

            }
    }



    // HUMBURGUER
    .menu-bars{
        position:fixed;
        top:10px;
        left:20px;
        color:white;
        cursor:pointer;
        background:color-orange;
        border-radius:50%;
        text-align:center;
        z-index:20;
       
        width larg = 45px;
        height larg;
        i{
            line-height:larg;
            font-size:20px;
        }
    
        display:none;

        +mobile(){
            display:block;
        }
    }





    #logowrap {
      
        min-width  220px;    
        transform scale(1);
        transform-origin 0 50%;
      
        margin-left: 10px;

        h1{
            transform scale(1);
            transform-origin 0 50%;
            color:white;
            font-family:'Asap'
            font-weight: bolder;
            font-style: italic;
            font-size:30px;
            line-height:0.8;
            text-decoration:none;

            .lago{
                padding-left:0.6em;
            }
        }
        
        +mobile(){
            // transform scale(0.6);
            // transform scale(0.8)

            position:fixed;
            right:20px;
            top:10px;
            h1{
                font-size:20px;
                text-align:right;
                 .lago{
                padding-right:0.6em;
            }
            }
        }
    }







    // LANGUAGE
    
    #lang-selector{
        // position:fixed;
        // top:0;
        // right:50px;
        // width:3em;
        text-align:center;
        margin-bottom 1em;
        // position:absolute;
        width: 100%;

        +mobile(){
            // right:initial;
            // left:1em;
        }

        a{
          
            display:inline-block;
            // border-top:2px solid transparent;
            color:rgba(white,0.6);
            cursor:pointer;
            opacity:0.5;
            transition 200ms opacity;
            font-size:0.8rem;
            padding: 0.3em 0.4em;
            background rgba(black,0.3);
            &:first-child{
                border-radius: 5px 0 0 5px;
            }
            &:last-child{
                border-radius: 0 5px 5px 0;
            }
            &:hover, &.active{
                 opacity 1;
                //  border-bottom:2px solid white;
            }
        }

    }


 


</style>